
const digest = 'ba6bf1558dc808902f15a955f72b9770a987e3c2aa0029714d80b5f7f14bc009';
const classes = {"button":"_button_fu8r8_1","purple":"_purple_fu8r8_9","red":"_red_fu8r8_13"};
const css = `._button_fu8r8_1 {
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
}

._purple_fu8r8_9 {
  color: #3c3f9c;
}

._red_fu8r8_13 {
  color: #B32323;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  